import { useEffect, useRef, useState } from 'react';

export const useSweatReminder = (totalPoints, interval, enabled) => {
  const [show, setShow] = useState(false);
  const lastShown = useRef(0);

  useEffect(() => {
    if (!enabled || interval <= 0) return;
    const bucket = Math.floor(totalPoints / interval);
    if (bucket > lastShown.current && totalPoints > 0) {
      lastShown.current = bucket;
      setShow(true);
      const t = setTimeout(() => setShow(false), 4000);
      return () => clearTimeout(t);
    }
  }, [totalPoints, interval, enabled]);

  return [show, () => setShow(false)];
};